import { setMetadata } from '@hcengineering/platform'
import board from '@hcengineering/board'
import chunter from '@hcengineering/chunter'
import contact from '@hcengineering/contact'
import docPlugin from '@hcengineering/document'
import drive from '@hcengineering/drive'
import hr from '@hcengineering/hr'
import inbox from '@hcengineering/inbox'
import lead from '@hcengineering/lead'
import notification from '@hcengineering/notification'
import recruit from '@hcengineering/recruit'
import setting from '@hcengineering/setting'
import support from '@hcengineering/support'
import time from '@hcengineering/time'
import tracker from '@hcengineering/tracker'

const icons = '/spelflow/icons.svg'

// Use setMetadata for individual keys to avoid loadMetadata's requirement
// of covering ALL keys in a plugin's metadata object.

setMetadata(inbox.icon.Inbox,                       `${icons}#inbox`)
setMetadata(notification.icon.Notifications,        `${icons}#notifications`)

setMetadata(tracker.icon.TrackerApplication,        `${icons}#tracker`)
setMetadata(tracker.icon.Home,                      `${icons}#tracker-home`)
setMetadata(tracker.icon.Issues,                    `${icons}#tracker-issues`)
setMetadata(tracker.icon.MyIssues,                  `${icons}#tracker-my-issues`)
setMetadata(tracker.icon.Views,                     `${icons}#tracker-views`)
setMetadata(tracker.icon.Labels,                    `${icons}#tracker-labels`)
setMetadata(tracker.icon.Components,                `${icons}#tracker-components`)
setMetadata(tracker.icon.IssueTemplates,            `${icons}#tracker-templates`)
setMetadata(tracker.icon.Inbox,                     `${icons}#tracker-inbox`)

setMetadata(chunter.icon.Chunter,                   `${icons}#chunter`)
setMetadata(chunter.icon.Messages,                  `${icons}#chunter-messages`)
setMetadata(chunter.icon.Bookmarks,                 `${icons}#chunter-bookmarks`)
setMetadata(chunter.icon.Hashtag,                   `${icons}#chunter-hashtag`)
setMetadata(chunter.icon.Thread,                    `${icons}#chunter-thread`)

setMetadata(hr.icon.HR,                             `${icons}#hr`)
setMetadata(hr.icon.Structure,                      `${icons}#hr-structure`)
setMetadata(hr.icon.Members,                        `${icons}#hr-members`)

setMetadata(contact.icon.ContactApplication,        `${icons}#contact`)
setMetadata(contact.icon.Contacts,                  `${icons}#contact-contacts`)

setMetadata(recruit.icon.RecruitApplication,        `${icons}#recruit`)
setMetadata(recruit.icon.Talents,                   `${icons}#recruit-talents`)
setMetadata(recruit.icon.AssignedToMe,              `${icons}#recruit-assigned`)
setMetadata(recruit.icon.Reviews,                   `${icons}#recruit-reviews`)
setMetadata(recruit.icon.Skills,                    `${icons}#recruit-skills`)

setMetadata(lead.icon.LeadApplication,              `${icons}#lead-app`)
setMetadata(docPlugin.icon.DocumentApplication,     `${icons}#document`)
setMetadata(drive.icon.DriveApplication,            `${icons}#drive`)
setMetadata(setting.icon.Setting,                   `${icons}#settings`)
setMetadata(support.icon.Support,                   `${icons}#support`)
setMetadata(board.icon.Board,                       `${icons}#board`)
setMetadata(time.icon.All,                          `${icons}#planner`)
